<template>

	<div class="articleSectionImage">
		<div
				:style="{'background-image': 'url(' + require('../assets/img/'+image) + ')', 'background-position': bgPos, 'background-size': bgSize}">
			<Caption v-if="caption" :title="caption"></Caption>
		</div>
	</div>

</template>

<script>
import Caption from "./Caption";

export default {
	name: "ArticleSectionImage",
	components: {Caption},
	props: ["image", "caption", "bgPos", "bgSize"],
	methods: {
		imgPath: function (img) {
			return require("../assets/img/" + img);
		}
	}
};
</script>

<style lang="scss" scoped>
.articleSectionImage {
	height: 100vh;
	padding: 0;
	margin: $G-default*2 0;

	@include breakpoint(xs) {
		height: auto;
		padding: 0;
	}

	& > div {
		background-attachment: fixed;
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
		height: 100%;
		position: relative;
		@include breakpoint(xs) {
			background-size: cover;
			background-attachment: initial;
			height: 60vw;
		}

		.caption {
			@include breakpoint(xs) {
				opacity: 0;
				transition: 0.25s;
			}
		}

		&:hover {
			.caption {
				@include breakpoint(xs) {
					opacity: 1;
					transition: 0.25s;
				}
			}
		}
	}

	&.noFixed {
		& > div {
			background-attachment: initial;
		}
	}

	.caption {
		position: absolute;
		bottom: $G-default;
		right: $G-default;
	}

	&.left_caption {
		.caption {
			right: auto;
			left: $G-default;
		}
	}
}
</style>